module.exports = __webpack_public_path__ + "static/img/10037.aaafff77.png";